import $ from "jquery";

$(document).ready(function () {

    function getUniqueId(str) {
        return str.split("Modal")[1];
    }

    var imageGalleries = $(".image-gallery");

    imageGalleries.each(function () {
        var modalGallery = $(this).siblings(".image-gallery-modal");
        var imageGalleryClone = $(this).clone();

        modalGallery.append(imageGalleryClone);
        var modalGalleryUniqueID = getUniqueId(modalGallery.attr("id"));

        var imageGalleryInModal = modalGallery.find(".image-gallery");
        imageGalleryInModal.attr("id", ("imageGalleryInModal" + modalGalleryUniqueID));

        var images = imageGalleryInModal.find(".carousel-image");

        images.addClass("position-relative translate-middle-y top-50");
        images.siblings("source").remove();
        images.each(function () {

            var newImageUrl = this.getAttribute("fullscreen-url");
            this.src = newImageUrl;
        });

        imageGalleryInModal.addClass("top-50 translate-middle-y");

        imageGalleryInModal.find(".carousel-indicators button").hide();
        imageGalleryInModal.find(".carousel-control-prev")
            .attr("data-bs-target", "#imageGalleryInModal" + modalGalleryUniqueID);
        imageGalleryInModal.find(".carousel-control-next")
            .attr("data-bs-target", "#imageGalleryInModal" + modalGalleryUniqueID);
        imageGalleryInModal.find(".carousel-control-fullscreen").hide();

    });

});